import type { ProjectPageProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

const ProjectPage = (props: ProjectPageProps) => {
  return <LazyComponent<ProjectPageProps> name="ProjectPage" {...props} />;
};

export default ProjectPage;
